import { Helmet } from 'react-helmet';

export const NoIndexTag = () => {
  return (
    <Helmet>
      <meta name="robots" content="noindex, noarchive" />
    </Helmet>
  );
};
